<template>
  <div class="swiperComponent">
    <el-collapse v-model="activeNames" style="width: 100%">
      <controlWidthAndSizeAndZindex :options="options" :ids="ids" />
      <el-collapse-item @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '1')" title="外观" name="1">
        <div class="setting-item" v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '1')">
          <div class="content">
            <slider-and-input
              class="mb16"
              inputWidth="small"
              inputHeight="small"
              :value.sync="opacity"
              title="透明度"
              :sliderMax="100"
              suffix="%"
            />
            <!-- <div class="verticallyCenter mb16 cx_style" style="line-height: 18px">
              <el-checkbox v-model="showCropping">裁剪内容</el-checkbox>
              <span class="third-text">(仅预览页生效)</span>
              <i class="tips-btn icon-portal-info2" @click="explainDialog = true"></i>
            </div> -->
            <div class="content-item mb16">
              <border-radius
                :borderTypeFlag.sync="borderTypeFlag"
                :borderRadius.sync="borderRadius"
                :borderTopLeftRadius.sync="borderTopLeftRadius"
                :borderTopRightRadius.sync="borderTopRightRadius"
                :borderBottomRightRadius.sync="borderBottomRightRadius"
                :borderBottomLeftRadius.sync="borderBottomLeftRadius"
              />
            </div>
            <div class="content-item mb16">
              <div class="mb16">边框</div>
              <div class="">
                <cx-border
                  :borderWidth.sync="borderWidth"
                  :borderStyle.sync="borderStyle"
                  :borderColor.sync="borderColor"
                  :borderIsThemeColor.sync="borderIsThemeColor"
                />
              </div>
            </div>
            <div class="content-item mb16">
              <cx-padding
                :paddingTypeFlag.sync="paddingTypeFlag"
                :padding.sync="padding"
                :paddingTop.sync="paddingTop"
                :paddingRight.sync="paddingRight"
                :paddingBottom.sync="paddingBottom"
                :paddingLeft.sync="paddingLeft"
              />
            </div>
            <div class="content-item mb16">
              <cx-background
                v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '4')"
                :background.sync="background"
                imgType="10"
              />
            </div>
            <div class="content-item">
              <div class="checkbox_colorPicker_container">
                <span>阴影</span>
                <span class="icon-portal-plus theme-color right-icon" @click="addBoxshadow"></span>
              </div>
              <box-shadow
                :boxShadowH.sync="boxShadowH"
                :boxShadowV.sync="boxShadowV"
                :boxShadowBlur.sync="boxShadowBlur"
                :boxShadowSpread.sync="boxShadowSpread"
                :boxShadowColor.sync="boxShadowColor"
              />
            </div>
          </div>
        </div>
      </el-collapse-item>
    </el-collapse>
    <el-dialog title="说明" :append-to-body="true" :visible.sync="explainDialog" custom-class="explainDialog">
      <p class="fs14 tips">
        勾选裁剪内容后，任何溢出容器的内容都将被隐藏，不会显示在容器的边界之外。<span>仅在预览页生效</span>
      </p>
      <div class="box">
        <img :src="explainImgSrc" v-if="explainImgSrc" alt="" class="img" />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import button from "./settings/button.vue"
import { Swiper3D as SwiperDep } from "../menus/model.js"
import controlWidthAndSizeAndZindex from "publicSetting/controlWidthAndSizeAndZindex.vue"
import { withMethodsHistoryCombine, historyCombineWrap } from "utils/revork"

const baseSwiper = new SwiperDep()
export default withMethodsHistoryCombine({
  components: {
    Button: button,
    controlWidthAndSizeAndZindex
  },
  name: "swiper-options",
  props: {
    options: { type: Object },
    container_id: { type: Number, default: null },
    rect_id: { type: Number, default: null }
  },
  data() {
    return {
      this1: this,
      defaultAutoPlay: {
        delay: 1000,
        stopOnLastSlide: false,
        disableOnInteraction: false
      },

      activeNames: ["0", "1", "5"],
      allCollapseNames: ["2", "3", "4"],
      collapseActiveNames: ["0", "1", "5"],
      activeNames2: [],
      paginationPositionSelect: [
        { label: "底部", value: "bottom" },
        { label: "顶部", value: "top" },
        { label: "左侧", value: "left" },
        { label: "右侧", value: "right" }
      ],
      paginationType: [
        { label: "圆点", value: "bullets" },
        // { label: "无", value: "none" },
        { label: "分数", value: "fraction" },
        { label: "进度条", value: "progressbar" }
      ],
      effect: [
        { label: "左右切换", value: "slide" },
        { label: "淡入", value: "fade" },
        { label: "方块", value: "cube" },
        { label: "3d流", value: "coverflow" },
        // { label: "卡片", value: "cards" },
        { label: "3d翻转", value: "flip" }
      ],
      directionType: [
        { label: "上", value: "top" },
        { label: "下", value: "bottom" },
        { label: "左", value: "left" },
        { label: "右", value: "right" }
      ],
      effectType: ["fade", "cube", "coverflow", "flip"], //slide模式没有啥配置项 不用初始化
      checkedL: true,
      checkedR: true,
      explainDialog: false,
      explainImgSrc: require("../../../assets/images/tipsVideoImg/cropping-img.png")
    }
  },
  methods: {
    //添加轮播content
    addContent() {
      let data = {
        ...this.ids,
        mode: "add"
      }
      delete data.swiperContent_id
      this.$store.dispatch(this.request_prefix + "/swiperContentControl", data)
    },
    addBoxshadow() {
      if (!Array.isArray(this.boxShadowH) || !Array.isArray(this.boxShadowColor)) {
        this.boxShadowH = [this.boxShadowH]
        this.boxShadowV = [this.boxShadowV]
        this.boxShadowBlur = [this.boxShadowBlur]
        this.boxShadowSpread = [this.boxShadowSpread]
        this.boxShadowColor = [this.boxShadowColor]
      }
      let boxShadowH = JSON.parse(JSON.stringify(this.boxShadowH))
      let boxShadowV = JSON.parse(JSON.stringify(this.boxShadowV))
      let boxShadowBlur = JSON.parse(JSON.stringify(this.boxShadowBlur))
      let boxShadowSpread = JSON.parse(JSON.stringify(this.boxShadowSpread))
      let boxShadowColor = JSON.parse(JSON.stringify(this.boxShadowColor))
      boxShadowH.push(0)
      boxShadowV.push(4)
      boxShadowBlur.push(4)
      boxShadowSpread.push(0)
      boxShadowColor.push("rgba(0,0,0,0.25)")
      this.boxShadowH = boxShadowH
      this.boxShadowV = boxShadowV
      this.boxShadowBlur = boxShadowBlur
      this.boxShadowSpread = boxShadowSpread
      this.boxShadowColor = boxShadowColor
    }
  },
  computed: {
    opacity: {
      get() {
        return this.options.hasOwnProperty("opacity") ? this.options.opacity : 100
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "opacity", false, null, this.getRectId)
      }
    },
    borderTopLeftRadius: {
      get() {
        return this.options.hasOwnProperty("borderTopLeftRadius") ? this.options.borderTopLeftRadius : 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderTopLeftRadius", false, null, this.getRectId)
      }
    },
    borderTopRightRadius: {
      get() {
        return this.options.hasOwnProperty("borderTopRightRadius") ? this.options.borderTopRightRadius : 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderTopRightRadius", false, null, this.getRectId)
      }
    },
    borderBottomRightRadius: {
      get() {
        return this.options.hasOwnProperty("borderBottomRightRadius") ? this.options.borderBottomRightRadius : 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderBottomRightRadius", false, null, this.getRectId)
      }
    },
    borderBottomLeftRadius: {
      get() {
        return this.options.hasOwnProperty("borderBottomLeftRadius") ? this.options.borderBottomLeftRadius : 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderBottomLeftRadius", false, null, this.getRectId)
      }
    },
    borderRadius: {
      get() {
        return this.options.hasOwnProperty("borderRadius") ? this.options.borderRadius : 0
      },
      set(newVal) {
        this.$changeOptionsEV(
          [newVal, newVal, newVal, newVal, newVal],
          [
            "borderRadius",
            "borderTopLeftRadius",
            "borderTopRightRadius",
            "borderBottomRightRadius",
            "borderBottomLeftRadius"
          ],
          false,
          null,
          this.getRectId
        )
      }
    },
    borderTypeFlag: {
      get() {
        let defaultType = 1
        if (!this.options.hasOwnProperty("borderTypeFlag")) {
          if (
            ((this.borderTopLeftRadius === this.borderTopRightRadius) === this.borderBottomLeftRadius) ===
            this.borderBottomRightRadius
          ) {
            defaultType = 2
          }
        }
        // 上面方法貌似是执行需要一定的时间，造成最开始还未写入值，进行点击 会出现问题
        return this.options.hasOwnProperty("borderTypeFlag") ? this.options.borderTypeFlag : defaultType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderTypeFlag", false, null, this.getRectId)
      }
    },
    borderStyle: {
      get() {
        return this.options.hasOwnProperty("borderStyle") ? this.options.borderStyle : "solid"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderStyle", false, null, this.getRectId)
      }
    },
    borderColor: {
      get() {
        return this.options.hasOwnProperty("borderColor") ? this.options.borderColor : "#000000"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderColor", false, null, this.getRectId)
      }
    },
    borderIsThemeColor: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "borderIsThemeColor", "borderIsThemeColor", false)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderIsThemeColor", false, null, this.getRectId)
      }
    },
    borderWidth: {
      get() {
        return this.options.hasOwnProperty("borderWidth") ? this.options.borderWidth : 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderWidth", false, null, this.getRectId)
      }
    },
    boxShadowColor: {
      get() {
        return this.options.hasOwnProperty("boxShadowColor") ? this.options.boxShadowColor : []
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowColor", false, null, this.getRectId)
      }
    },
    boxShadowH: {
      get() {
        return this.options.hasOwnProperty("boxShadowH") ? this.options.boxShadowH : []
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowH", false, null, this.getRectId)
      }
    },
    boxShadowV: {
      get() {
        return this.options.hasOwnProperty("boxShadowV") ? this.options.boxShadowV : []
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowV", false, null, this.getRectId)
      }
    },
    boxShadowBlur: {
      get() {
        return this.options.hasOwnProperty("boxShadowBlur") ? this.options.boxShadowBlur : []
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowBlur", false, null, this.getRectId)
      }
    },
    boxShadowSpread: {
      get() {
        return this.options.hasOwnProperty("boxShadowSpread") ? this.options.boxShadowSpread : []
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowSpread", false, null, this.getRectId)
      }
    },
    // 边距
    paddingTypeFlag: {
      get() {
        let defaultType = 1
        if (!this.options.hasOwnProperty("paddingTypeFlag")) {
          if (((this.paddingTop === this.paddingRight) === this.paddingLeft) === this.paddingBottom) {
            defaultType = 2
          }
        }
        return this.checkAndSetPrimaryVal(this.options, "paddingTypeFlag", "paddingTypeFlag", defaultType)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "paddingTypeFlag", false, null, this.getRectId)
      }
    },
    padding: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "padding", "padding", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "padding", false, null, this.getRectId)
      }
    },
    paddingTop: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "paddingTop", "paddingTop", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "paddingTop", false, null, this.getRectId)
      }
    },
    paddingRight: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "paddingRight", "paddingRight", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "paddingRight", false, null, this.getRectId)
      }
    },
    paddingLeft: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "paddingLeft", "paddingLeft", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "paddingLeft", false, null, this.getRectId)
      }
    },
    paddingBottom: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "paddingBottom", "paddingBottom", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "paddingBottom", false, null, this.getRectId)
      }
    },
    background: {
      get() {
        let background = this.checkAndSetPrimaryVal(this.options, "background", "background", "")
        if (background && Array.isArray(background) && background.length > 0) {
          return this.options.background
        }
        let newBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: this.allBgColorIsThemeColor,
            color: this.options.bgColor
          }
        ]
        this.$changeOptionsEV(newBackground, "background", false, null, this.getRectId, true)
        return newBackground
      },
      set(val) {
        this.$changeOptionsEV(val, "background", false, null, this.getRectId)
      }
    },
    allBgColorIsThemeColor: {
      get() {
        return this.options.hasOwnProperty("allBgColorIsThemeColor") ? this.options.allBgColorIsThemeColor : false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "allBgColorIsThemeColor", false, null, this.getRectId)
      }
    },
    getRectId() {
      let ids = {
        container_id: this.ids.container_id,
        rect_id: this.ids.rect_id
      }
      if (this.ids.elementInAutoLayoutId !== undefined && this.ids.elementInAutoLayoutId !== null) {
        ids = {
          container_id: this.ids.container_id,
          rect_id: this.ids.rect_id,
          elementInAutoLayoutId: this.ids.elementInAutoLayoutId,
          path: this.ids.path
        }
      }
      return ids
    },
    isChild() {
      if (this.ids.uid) return true
      else return false
    },

    left: {
      get() {
        return this.options.left
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "left", false, null, this.getRectId)
      }
    },
    top: {
      get() {
        return this.options.top
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "top", false, null, this.getRectId)
      }
    },
    width: {
      get() {
        return this.options.width
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "width", false, null, this.getRectId)
      }
    },
    height: {
      get() {
        return this.options.height
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "height", false, null, this.getRectId)
      }
    },
    rotate: {
      get() {
        return this.options.rotate
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "rotate", false, null, this.getRectId)
      }
    },
    bulletsPrimaryColor: {
      get() {
        return this.options.pagination.bulletsPrimaryColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "bulletsPrimaryColor", true, "pagination", this.getRectId)
      }
    },
    bulletsActiveColor: {
      get() {
        return this.options.pagination.bulletsActiveColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "bulletsActiveColor", true, "pagination", this.getRectId)
      }
    },
    progressbarBackground: {
      get() {
        return this.options.progressbarBackground
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "progressbarBackground", false, null, this.getRectId)
      }
    },

    showPagination: {
      get() {
        return this.options.showPagination
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "showPagination", false, null, this.getRectId)
      }
    },
    loop: {
      get() {
        return this.options.loop
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "loop", false, null, this.getRectId)
      }
    },
    autoPlay: {
      get() {
        return !!this.options.autoPlay
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "autoPlay", false, null, this.getRectId)
      }
    },
    paginationTypes: {
      get() {
        return this.options.pagination.type
      },
      set(newVal) {
        if (!this.showPagination) {
          this.$changeOptionsEV([true, newVal], ["showPagination", "pagination.type"], false, null, this.getRectId)
        } else {
          this.$changeOptionsEV(newVal, "pagination.type", false, null, this.getRectId)
        }
      }
    },
    paginationClickable: {
      get() {
        return this.options.pagination.clickable
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "clickable", true, "pagination", this.getRectId)
      }
    },
    paginationPosition: {
      get() {
        return this.options.paginationPosition
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "paginationPosition", false, null, this.getRectId)
      }
    },
    bulletsSize: {
      get() {
        return this.options.bulletsSize
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "bulletsSize", false, null, this.getRectId)
      }
    },
    bulletsMargin: {
      get() {
        return this.options.bulletsMargin
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "bulletsMargin", false, null, this.getRectId)
      }
    },

    pagination: {
      get() {
        return this.options.pagination
      },
      set(newVal) {}
    },
    slidesPerView: {
      get() {
        return this.options.slidesPerView
      },
      set(newVal) {
        if (this.slidesPerView !== newVal) {
          this.$changeOptionsEV(newVal, "slidesPerView", false, null, this.getRectId)
        }
      }
    },
    effects: {
      get() {
        return this.options.effect
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "effect", false, null, this.getRectId)
      }
    },
    crossFade: {
      get() {
        return this.checkAndSetPrimaryVal(
          this.options,
          "fadeEffect.crossFade",
          "crossFade",
          baseSwiper.fadeEffect.crossFade
        )
      },
      set(newVal) {
        if (!this.options.fadeEffect) {
          this.$changeOptionsEV(
            { ...baseSwiper.fadeEffect, crossFade: newVal },
            "fadeEffect",
            false,
            null,
            this.getRectId
          )
        } else {
          this.$changeOptionsEV(newVal, "crossFade", true, "fadeEffect", this.getRectId)
        }
      }
    },
    showBigImg: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "showBigImg", "showBigImg", false)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "showBigImg", false, null, this.getRectId)
      }
    },
    slideShadows: {
      get() {
        return this.checkAndSetPrimaryVal(
          this.options,
          "cubeEffect.slideShadows",
          "slideShadows",
          baseSwiper.cubeEffect.slideShadows
        )
      },
      set(newVal) {
        if (!this.options.cubeEffect) {
          this.$changeOptionsEV(baseSwiper.cubeEffect, "cubeEffect", false, null, this.getRectId)
        }
        this.$changeOptionsEV(newVal, "slideShadows", true, "cubeEffect", this.getRectId)
      }
    },
    shadow: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "cubeEffect.shadow", "shadow", baseSwiper.cubeEffect.shadow)
      },
      set(newVal) {
        if (!this.options.cubeEffect) {
          this.$changeOptionsEV({ ...baseSwiper.cubeEffect, shadow: newVal }, "cubeEffect", false, null, this.getRectId)
        } else {
          this.$changeOptionsEV(newVal, "shadow", true, "cubeEffect", this.getRectId)
        }
      }
    },
    effectRotate: {
      get() {
        return this.checkAndSetPrimaryVal(
          this.options,
          "coverflowEffect.rotate",
          "effectRotate",
          baseSwiper.coverflowEffect.rotate
        )
      },
      set(newVal) {
        if (!this.options.coverflowEffect) {
          this.$changeOptionsEV(
            { ...baseSwiper.coverflowEffect, rotate: newVal },
            "coverflowEffect",
            false,
            null,
            this.getRectId
          )
        } else {
          this.$changeOptionsEV(newVal, "rotate", true, "coverflowEffect", this.getRectId)
        }
      }
    },
    stretch: {
      get() {
        return this.checkAndSetPrimaryVal(
          this.options,
          "coverflowEffect.stretch",
          "stretch",
          baseSwiper.coverflowEffect.stretch
        )
      },
      set(newVal) {
        if (!this.options.coverflowEffect) {
          this.$changeOptionsEV(
            { ...baseSwiper.coverflowEffect, stretch: newVal },
            "coverflowEffect",
            false,
            null,
            this.getRectId
          )
        } else {
          this.$changeOptionsEV(newVal, "stretch", true, "coverflowEffect", this.getRectId)
        }
      }
    },
    depth: {
      get() {
        return this.checkAndSetPrimaryVal(
          this.options,
          "coverflowEffect.depth",
          "depth",
          baseSwiper.coverflowEffect.depth
        )
      },
      set(newVal) {
        if (!this.options.coverflowEffect) {
          this.$changeOptionsEV(
            { ...baseSwiper.coverflowEffect, depth: newVal },
            "coverflowEffect",
            false,
            null,
            this.getRectId
          )
        } else {
          this.$changeOptionsEV(newVal, "depth", true, "coverflowEffect", this.getRectId)
        }
      }
    },
    modifier: {
      get() {
        return this.checkAndSetPrimaryVal(
          this.options,
          "coverflowEffect.modifier",
          "modifier",
          baseSwiper.coverflowEffect.modifier
        )
      },
      set(newVal) {
        if (!this.options.coverflowEffect) {
          this.$changeOptionsEV(
            { ...baseSwiper.coverflowEffect, modifier: newVal },
            "coverflowEffect",
            false,
            null,
            this.getRectId
          )
        } else {
          this.$changeOptionsEV(newVal, "modifier", true, "coverflowEffect", this.getRectId)
        }
      }
    },
    coverflowSlideShadows: {
      get() {
        return this.checkAndSetPrimaryVal(
          this.options,
          "coverflowEffect.slideShadows",
          "coverflowSlideShadows",
          baseSwiper.coverflowEffect.slideShadows
        )
      },
      set(newVal) {
        if (!this.options.coverflowEffect) {
          this.$changeOptionsEV(
            { ...baseSwiper.coverflowEffect, slideShadows: newVal },
            "coverflowEffect",
            false,
            null,
            this.getRectId
          )
        } else {
          this.$changeOptionsEV(newVal, "slideShadows", true, "coverflowEffect", this.getRectId)
        }
      }
    },
    shadowOffset: {
      get() {
        return this.checkAndSetPrimaryVal(
          this.options,
          "cubeEffect.shadowOffset",
          "shadowOffset",
          baseSwiper.cubeEffect.shadowOffset
        )
      },
      set(newVal) {
        if (!this.options.cubeEffect) {
          this.$changeOptionsEV(
            { ...baseSwiper.cubeEffect, shadowOffset: newVal },
            "cubeEffect",
            false,
            null,
            this.getRectId
          )
        } else {
          this.$changeOptionsEV(newVal, "shadowOffset", true, "cubeEffect", this.getRectId)
        }
      }
    },
    shadowScale: {
      get() {
        return (
          this.checkAndSetPrimaryVal(
            this.options,
            "cubeEffect.shadowScale",
            "shadowScale",
            baseSwiper.cubeEffect.shadowScale
          ) * 10
        )
      },
      set(newVal) {
        if (!this.options.cubeEffect) {
          this.$changeOptionsEV(
            { ...baseSwiper.cubeEffect, shadowScale: newVal / 10 },
            "cubeEffect",
            false,
            null,
            this.getRectId
          )
        } else {
          this.$changeOptionsEV(newVal / 10, "shadowScale", true, "cubeEffect", this.getRectId)
        }
      }
    },
    flipSlideShadows: {
      get() {
        return this.checkAndSetPrimaryVal(
          this.options,
          "flipEffect.slideShadows",
          "flipSlideShadows",
          baseSwiper.flipEffect.slideShadows
        )
      },
      set(newVal) {
        if (!this.options.flipEffect) {
          this.$changeOptionsEV(
            { ...baseSwiper.flipEffect, slideShadows: newVal },
            "flipEffect",
            false,
            null,
            this.getRectId
          )
        } else {
          this.$changeOptionsEV(newVal, "slideShadows", true, "flipEffect", this.getRectId)
        }
      }
    },
    limitRotation: {
      get() {
        return this.checkAndSetPrimaryVal(
          this.options,
          "flipEffect.limitRotation",
          "limitRotation",
          baseSwiper.flipEffect.limitRotation
        )
      },
      set(newVal) {
        if (!this.options.flipEffect) {
          this.$changeOptionsEV(
            { ...baseSwiper.flipEffect, limitRotation: newVal },
            "flipEffect",
            false,
            null,
            this.getRectId
          )
        } else {
          this.$changeOptionsEV(newVal, "limitRotation", true, "flipEffect", this.getRectId)
        }
      }
    },
    direction: {
      get() {
        let res,
          direction = this.options.direction,
          autoplay = this.options.autoplay
        switch (direction) {
          case "horizontal": //横向
            if (autoplay) {
              if (autoplay.reverseDirection) {
                res = "left"
              } else {
                res = "right"
              }
            } else {
              res = "right"
            }
            break
          case "vertical": //纵向
          case !autoplay:
            if (autoplay) {
              if (autoplay.reverseDirection) {
                res = "top"
              } else {
                res = "bottom"
              }
            } else {
              res = "bottom"
            }
            break
          default:
            break
        }
        return res
      },
      set(newVal) {
        historyCombineWrap(() => {
          let autoplay = this.options.autoplay
          switch (newVal) {
            case "left":
              if ("topbottom".includes(this.direction)) {
                this.$changeOptionsEV("horizontal", "direction", false, null, this.getRectId)
              }
              if (autoplay) {
                this.$changeOptionsEV(true, "autoplay.reverseDirection", false, null, this.getRectId)
              } else {
                this.defaultAutoPlay.reverseDirection = true
                this.autoplay = true
                this.defaultAutoPlay.reverseDirection = false
              }
              break
            case "right":
              if ("topbottom".includes(this.direction)) {
                this.$changeOptionsEV("horizontal", "direction", false, null, this.getRectId)
              }
              if (autoplay) {
                if (autoplay.reverseDirection) {
                  this.$changeOptionsEV(false, "autoplay.reverseDirection", false, null, this.getRectId)
                }
              } else {
                autoplay = true
              }
              break
            case "top":
              if ("leftright".includes(this.direction)) {
                this.$changeOptionsEV("vertical", "direction", false, null, this.getRectId)
              }
              if (autoplay) {
                if (!autoplay.reverseDirection) {
                  this.$changeOptionsEV(true, "autoplay.reverseDirection", false, null, this.getRectId)
                }
              } else {
                this.defaultAutoPlay.reverseDirection = true
                this.autoplay = true
                this.defaultAutoPlay.reverseDirection = false
              }
              break
            case "bottom":
              if ("leftright".includes(this.direction)) {
                this.$changeOptionsEV("vertical", "direction", false, null, this.getRectId)
              }
              if (autoplay) {
                if (autoplay.reverseDirection) {
                  this.$changeOptionsEV(false, "autoplay.reverseDirection", false, null, this.getRectId)
                }
              } else {
                this.autoplay = true
              }
              break
            default:
              break
          }
        })()
      }
    },
    content: {
      get() {
        return this.options.content
      }
    },
    speed: {
      get() {
        return this.options.speed
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "speed", false, null, this.getRectId)
      }
    },
    swiperContent: {
      get() {
        return this.options.content.length
      },
      set(newVal) {
        if (this.swiperContent == newVal) return
        if (newVal < this.swiperContent) {
          let data = {
            ...this.ids,
            mode: "sub"
          }
          delete data.swiperContent_id
          this.$store.dispatch(this.request_prefix + "/swiperContentControl", data)
        } else {
          let data = {
            ...this.ids,
            mode: "add"
          }
          delete data.swiperContent_id
          this.$store.dispatch(this.request_prefix + "/swiperContentControl", data)
        }
      }
    },
    swiper() {
      if (this.options !== null) {
        return {
          speed: this.options.speed,
          bgurl: [],
          content: this.options.content
        }
      }
      if (this.options == null && this.ids.uid !== null) {
        let result = JSON.parse(window.localStorage.getItem("tempOptions"))
        return {
          speed: result.speed,
          bgurl: [],
          content: result.content
        }
      }
      return null
    },
    ids() {
      return this.$store.state.states.activeID
    },
    // 是否裁剪内容
    showCropping: {
      get() {
        // 默认裁剪
        return this.options.hasOwnProperty("showCropping") ? this.options.showCropping : true
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "showCropping", false, null, this.getRectId)
      }
    },
  },
  mounted() {
    this.$collapseControl({
      allCollapseNames: this.allCollapseNames,
      collapseActiveNames: this.collapseActiveNames,
      activeNames: this.activeNames
    })
  }
})
</script>

<style scoped>
.swiperComponent {
  font-size: 14px;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  align-items: center;
}
.optionName {
  margin-right: 10px;
  width: auto;
}
.optionItem_switch_box {
  width: 100%;
  display: flex;
  margin-bottom: 10px;
  flex-wrap: wrap;
  flex-direction: row;
  align-content: center;
}
.harf_item {
  width: 50% !important;
}
.optionItem {
  margin-bottom: 10px;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  align-items: center;
}
.checkBox {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
}
.checkBox > div {
  width: 30%;
}
.swiper-content {
  margin-bottom: 10px;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: left;
}
::v-deep .el-input-number span {
  display: flex !important;
  flex-direction: column !important;
  justify-content: center !important;
  height: 93% !important;
}
</style>
